export enum BlockUIEventType {
  Show,
  Hide
}
